import PropTypes from 'prop-types'

export const analyticsProps = {
  /** Configures analytics for the field */
  analytics: PropTypes.shape({
    /** Wether to disable analytics events to be captured and registered or not */
    disabled: PropTypes.bool,
    /** Data to override the values that are sent by the field to the analytics event */
    data: PropTypes.shape({
      href: PropTypes.string,
      activated: PropTypes.bool,
      text: PropTypes.string,
    }),
  }),
  /** Backwards compability with react-button */
  analyticsContexts: PropTypes.arrayOf(PropTypes.object),
}
